export enum PricelistsViewEnum {
  DASHBOARD = 'Dashboard',
  CREATE = 'Create new pricelist',
}

export enum PricelistsPageParamsEnum {
  DASHBOARD = 'dashboard',
  CREATE = 'create-new-pricelist',
}
